import * as PatientInsuranceInformation from '../../models/patient/insuranceInformation';
import { Common } from '../../common';
import {
  ImportPatientOrder,
  PatientOrder,
  PatientOrderPopulated,
  RawPatientOrder,
  UpdateStatus,
} from '../../models/patient/order';
import { ImportValidation } from '../../models/provider';

export class API {
  common: Common;

  constructor(common: Common) {
    this.common = common;
  }

  async upload(feedId: string, practiceId: string, orders: RawPatientOrder[]) {
    const url = this.common.constructPath(`/patient-orders/sync/upload`);
    return this.common.postJSON(url, { feedId, practiceId, orders });
  }

  async importVerify(args: {
    feedId: string;
    practiceId: string;
    importRows: Record<string, string>[];
  }): Promise<Record<string, ImportValidation>[]> {
    const url = this.common.constructPath(`/patient-orders/sync/import/verify`);
    return this.common.postJSON(url, args);
  }

  async import(args: {
    feedId: string;
    feedUploadId?: string;
    practiceId: string;
    importRows: ImportPatientOrder[];
  }) {
    const url = this.common.constructPath(`/patient-orders/sync/import`);
    return this.common.postJSON(url, args);
  }

  async findAll(ehrInformationId: string): Promise<PatientOrder[]> {
    const url = this.common.constructPath(`/patient-orders`, {
      ehrInformationId,
    });
    return this.common.getJSON(url);
  }

  async findAllInsurance(
    id: string,
  ): Promise<PatientInsuranceInformation.InsuranceInformation[]> {
    const url = this.common.constructPath(`/patient-orders/${id}/insurances`);
    return this.common.getJSON(url);
  }

  async findOneById(id: string): Promise<PatientOrderPopulated> {
    const url = this.common.constructPath(`/patient-orders/${id}`);
    return this.common.getJSON(url);
  }

  async updateStatus(
    id: string,
    values: UpdateStatus,
  ): Promise<UpdateStatus & { patientOrderId: string }> {
    const url = this.common.constructPath(
      `/patient-orders/${id}/authorization-statuses`,
    );
    return this.common.postJSON(url, values);
  }

  async patchStatus(id: string, values: { note?: string | null }) {
    const url = this.common.constructPath(
      `/patient-orders/${id}/authorization-statuses`,
    );
    return this.common.patchJSON(url, values);
  }

  async update(
    id: string,
    values: Partial<PatientOrderPopulated>,
  ): Promise<PatientOrderPopulated> {
    const url = this.common.constructPath(`/patient-orders/${id}`);
    return this.common.patchJSON(url, values);
  }
}
